import { IEltTopIssue } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltTopIssue'

export const getDocTopIssuesInitialValues = (): IEltTopIssue[] => [
  {
    Issue: 'Issue 1',
    HpProgress: 'HP Progress/Actions',
  },
  {
    Issue: 'Issue 2',
    HpProgress: 'HP Progress/Actions',
  },
  {
    Issue: 'Issue 3',
    HpProgress: 'HP Progress/Actions',
  },
]
